export default "__VITE_ASSET__ceb8646b__"